import React from "react";
import Header from "./header";
import Footer from "./footer";
import { string, object, number } from "prop-types";
import "./layout-seventh.scss";
import "./survey-form.scss";
import "./blog-seventh.scss";

const LayoutSeventh = (props) => {
  const { children, pageType, siteData, page, isPageRefreshed } = props;

  return (
    <div className="seventh_layout_global">
      <div
        className={`layout_seventh-${
          siteData.primary_color &&
          siteData.primary_color !== undefined &&
          siteData.primary_color !== "" &&
          siteData.primary_color !== null
            ? siteData.primary_color
            : "default-theme"
        }`}
      >
        <Header siteData={siteData} pageType={pageType} page={page} />
        <main role="main">{children}</main>
        <Footer
          siteData={siteData}
          pageType={pageType}
          page={page}
          isPageRefreshed={isPageRefreshed}
        />
      </div>
    </div>
  );
};

export default LayoutSeventh;

LayoutSeventh.propTypes = {
  pageType: string,
  siteData: object,
  page: number,
};

LayoutSeventh.defaultProps = {
  pageType: "home",
  page: 1,
};
